/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankStatus } from '../../models/bank-status';
import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';

export interface UpdateStatusCustomerBankAsync$Params {
  id: number;
  bankId: number;
  status: BankStatus;
}

export function updateStatusCustomerBankAsync(http: HttpClient, rootUrl: string, params: UpdateStatusCustomerBankAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, updateStatusCustomerBankAsync.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('bankId', params.bankId, {});
    rb.path('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

updateStatusCustomerBankAsync.PATH = '/api/customer/{id}/bank/{bankId}/status/{status}';
